import ASM from "./ASM";

const Logo = ({ h = 55 }) => {
  if (process.env.REACT_APP_NAME === "ASM") {
    return <ASM h={h} />;
  }

  return <></>;
};

export default Logo;
